











import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import PortalMenuSkeltonLoader from '@/components/atoms/skelton/PortalMenuSkeltonLoader.vue';
import PortalHistoryMenusPanel from '@/components/organisms/PortalHistoryMenusPanel.vue';
import { ClickProductUrlEvent, ProductMenu } from '@/types/type';

@Component({
  components: { PortalMenuSkeltonLoader, PortalHistoryMenusPanel },
})
export default class PortalHistoryMenus extends Vue {
  @Prop()
  private loading!: boolean;

  @Prop()
  private menus!: ProductMenu[];

  @Emit('history-menu-opened')
  private afterMenuOpen(event: ClickProductUrlEvent): ClickProductUrlEvent {
    return event;
  }
}
